import { getStoreKey } from './utils';
import localStorage from './localStorage';
import memoryStorage from './memoryStorage';

const obfuscate = (content) => {
    const primero = btoa(content);
    let segundo = '';
    // eslint-disable-next-line for-direction
    for (let i = primero.length - 1; i >= 0; i -= 1) {
        segundo += primero[i];
    }

    return segundo;
};

const unObfuscate = (content) => {
    let primero = '';
    // eslint-disable-next-line for-direction
    for (let i = content.length - 1; i >= 0; i -= 1) {
        primero += content[i];
    }
    const segundo = atob(primero);

    return segundo;
};

/**
 * Returns the tokenStorage
 * @param {Object} params
 * @param {('localStorage'|'memory')} params.type - Storage type
 * @param {String} params.clientId - Auth0 clientId
 * @param {String} params.audience - Auth0 audience
 * @param {boolean} [params.obfuscate=true] - Obfuscate store content
 * @returns {import('../../types/store').TokenStoreInterface}  - Token storage
 */
const getTokenStorage = (params) => {
    /** @type {import('../../types/store').InternalTokenStoreInterface} */
    let storage;
    const key = getStoreKey(params);
    switch (params.type) {
        case 'localStorage':
            storage = localStorage(key);
            break;
        case 'memory':
            storage = memoryStorage(key);
            break;
        default:
            throw new Error('Invalid Storage type');
    }
    const overrideSet = (tokens) => {
        if (tokens && typeof tokens === 'object') {
            const stringTokens = JSON.stringify(tokens);
            storage.set(
                params.obfuscate ? obfuscate(stringTokens) : stringTokens
            );
        }
    };

    const finalStorage = {
        ...storage,
        get: () => {
            try {
                const stringToken = storage.get();
                const tokens = stringToken
                    ? JSON.parse(
                          params.obfuscate
                              ? unObfuscate(stringToken)
                              : stringToken
                      )
                    : undefined;

                if (tokens && tokens.expiresAt < Date.now()) {
                    delete tokens.accessToken;
                    delete tokens.idToken;
                    delete tokens.scope;

                    overrideSet(tokens);
                }
                return tokens;
            } catch (error) {
                // Alterado o cambio de config
                storage.remove();
                return undefined;
            }
        },
        set: overrideSet,
    };

    return finalStorage;
};

export default getTokenStorage;
